import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  Id: number;
  fullName: string;
  username: string;
}

const initialState: UserState = {
  Id: 0,
  fullName: "",
  username: "",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<Partial<UserState>>) => {
      return { ...state, ...action.payload };
    },
  
  },
});

export const { setUser } = userSlice.actions;
export const userReducer = userSlice.reducer;
